export function toUserId(delegate) {
  return `${delegate.FirstName}_${
    delegate.Surname
  }_${delegate.DateOfBirth.replaceAll("-")}`
    .replace(/\W/g, "")
    .toUpperCase();
}
